import { Vue, Component, Prop } from "vue-property-decorator";

// Helpers
import { getEmptyProductImageUrl } from "@/plugins/products_helper";

@Component({})
export default class ChefSuggestionCard extends Vue {
  @Prop({ default: null }) chefSuggestion;

  get chefSuggestionOverPrice() {
    let totalOverPrice = 0;
    const { product_menu_items } = this.chefSuggestion;
    product_menu_items.forEach((item) => (totalOverPrice += item.over_price));
    return totalOverPrice;
  }

  get chefSuggestionInfo() {
    let response = "";
    const { product_menu_items } = this.chefSuggestion;
    product_menu_items.forEach((item, index) => {
      if (index === product_menu_items.length - 1) response += `${item.name}.`;
      else response += `${item.name}, `;
    });
    return response;
  }

  getProductMenuItemImage(productMenuItem) {
    const { img } = productMenuItem;
    if (!img || !img.url) return getEmptyProductImageUrl();
    return img.url;
  }
}
